<wl-content-section [id]="id()" [theme]="theme()">
  <wl-extended-usps-section
    [uid]="uid()!"
    [title]="title()!"
    [introduction]="introduction()!"
    [extendedUsps]="extendedUsps()"
    [callToAction]="callToAction()"
    [inverted]="inverted()"
  />
</wl-content-section>
